import React from 'react'
import axios from 'axios'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import DBConn from '~/Classes/siteVars.js'
import { connect } from 'react-redux'
import queryString from 'query-string'
import LandingPageTemplate from '../login/template'
import i18n from '~/i18n'
import { isPasswordStrongEnough } from '~/utils/passwordPolicy'
@connect((store) => {
    return {
        user: store.user,
        siteMaster: store.siteMaster
    }
})
export default class ActivateTemplate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            accountMasterData: {},
            requiresPassword: false,
            pageLoaded: false,
            firstName: '',
            lastName: '',
            password: '',
            errors: {
                password: null,
                firstName: null,
                lastName: null,
                terms: null
            },
            tokenInvalid: false,
            processing: false,
            type: 'password',
            newsletterSignup: false,
            approvedTerms: false
        }

        this.inputChange = this.inputChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        const query = queryString.parse(location.search)
        const ourToken = query.token

        var baseUrl = DBConn.getConnString()

        //lookup token and see if its a brand new user
        axios
            .get(baseUrl + '/register?token=' + ourToken)
            .then((res) => {
                if (res.data.Success) {
                    this.setState({
                        accountMasterData: res.data.AccountMaster,
                        requiresPassword: true, //res.data.RequiresPassword,
                        pageLoaded: true
                    })
                } else {
                    this.setState({
                        tokenInvalid: true
                    })
                }
            })
            .catch((err) => {
                this.setState({ tokenInvalid: true })
            })
    }

    inputChange(ev) {
        this.setState({ [ev.currentTarget.name]: ev.currentTarget.value }, () => {
            if (this.state.touched) this.validate()
        })
    }

    validate() {
        const requiresTerms =
            (this.props.siteMaster.termsUrl && this.props.siteMaster.termsUrl.length > 5) ||
            (this.props.siteMaster.privacyUrl && this.props.siteMaster.privacyUrl.length > 5)
        const errors = {
            firstName: '',
            lastName: '',
            password: '',
            terms: false
        }
        let fail = 0
        if (this.state.requiresPassword) {
            if (!this.state.firstName || this.state.firstName.length < 2) {
                errors.firstName = 'Enter a valid First Name'
                fail = 1
            }
            if (!this.state.lastName || this.state.lastName.length < 2) {
                errors.lastName = 'Enter a valid Last Name'
                fail = 1
            }
            if (!this.state.password) {
                errors.password = i18n.t('login:register.blankPassword', { siteName: this.props.siteMaster.siteName })
                fail = 1
            } else if (!isPasswordStrongEnough(this.state.password)) {
                errors.password = i18n.t('login:reset.strong')
                fail = 1
            }
            if (!this.state.approvedTerms && requiresTerms) {
                errors.terms = true
                fail = 1
            }
        }
        this.setState({ errors: errors })
        return fail
    }

    handleSubmit() {
        var self = this
        const query = queryString.parse(location.search)
        const ourToken = query.token
        var errors = this.state.errors

        this.setState({ processing: true, touched: true })

        errors.firstName = ''
        errors.lastName = ''
        errors.password = ''
        errors.terms = false

        var data = {
            token: ourToken
        }
        var fail = this.validate()

        if (fail === 1) {
            this.setState({ processing: false })
        } else {
            if (this.state.requiresPassword) {
                data.firstName = this.state.firstName
                data.lastName = this.state.lastName
                data.password = this.state.password
                data.newsletterSignup = this.state.newsletterSignup
            }

            var baseUrl = DBConn.getConnString()

            axios
                .put(baseUrl + '/register', data)
                .then((res) => {
                    self.props.dispatch({ type: 'LOGGEDIN_SUCCESS', payload: res.data })
                    var query = queryString.parse(location.search)

                    if (query.redirect) {
                        console.log('redirecting to', console.log(query.redirect))
                        window.open(query.redirect, '_self')
                    } else {
                        window.open('/cp', '_self')
                    }
                })
                .catch((err) => {
                    errors.password = 'There was a problem registering your account'
                    if (err) {
                        if (err.response.data) {
                            if (err.response.data.error) {
                                errors.password = err.response.data.error
                            }
                        }
                    }
                    self.setState({ errors: errors, processing: false })
                })
        }
    }

    render() {
        if (this.state.tokenInvalid) {
            return (
                <div className='quickFlex' style={{ alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                    <Paper className='with_header'>
                        <div
                            className='paper_header'
                            style={{ backgroundColor: this.props.siteMaster.colours['$primary'], color: 'white' }}
                        >
                            <div className='quickFlex' style={{ alignItems: 'center' }}>
                                <Icons icon='alert' color={'#FFFFFF'} style={{ width: '20px', height: '20px' }} />
                                <div className='mar-l10 text-heavy' style={{ fontSize: 16 }}>
                                    Token Has Expired
                                </div>
                            </div>
                        </div>
                        <div className='paper_content'>
                            <div className='mar-b10'>The token has expired.</div>
                            <div className='mar-b25'>
                                You might need to ask the person who invited you to invite you again!
                            </div>
                            <Button
                                text='Continue'
                                onClick={() => {
                                    this.props.history.push('/')
                                }}
                            />
                        </div>
                    </Paper>
                </div>
            )
        }
        if (this.state.pageLoaded === false) {
            return <LoadingIcons />
        } else {
            let header = 'Create your account'
            let subheader = (
                <div>
                    You've been invited to join <strong>{this.state.accountMasterData.name}</strong> in{' '}
                    {this.props.siteMaster.siteName}. Enter your details below to activate your account.
                </div>
            )
            let buttonText = 'Activate your account'
            if (!this.state.requiresPassword) {
                header = 'Activate your account'
                subheader = (
                    <div>
                        You've been invited to join <strong>{this.state.accountMasterData.name}</strong> in{' '}
                        {this.props.siteMaster.siteName}. Click the button below to activate your account.
                    </div>
                )
                buttonText = 'Accept invitation'
            }
            let requiresTerms = false
            if (
                (this.props.siteMaster.termsUrl && this.props.siteMaster.termsUrl.length > 5) ||
                (this.props.siteMaster.privacyUrl && this.props.siteMaster.privacyUrl.length > 5)
            ) {
                requiresTerms = true
            }

            return (
                <LandingPageTemplate header={header} subheader={subheader} paperClasses='landing-register'>
                    {this.state.requiresPassword && (
                        <>
                            <div className='row'>
                                <div className='col-xs-12 col-sm-6'>
                                    <TextInput
                                        label={i18n.t('login:register.first')}
                                        outerClassName='mar-b16'
                                        type='text'
                                        name='firstName'
                                        value={this.state.firstName}
                                        onChange={this.inputChange}
                                        error={this.state.errors.firstName}
                                    />
                                </div>
                                <div className='col-xs-12 col-sm-6'>
                                    <TextInput
                                        label={i18n.t('login:register.last')}
                                        outerClassName='mar-b16'
                                        type='text'
                                        name='lastName'
                                        value={this.state.lastName}
                                        onChange={this.inputChange}
                                        error={this.state.errors.lastName}
                                    />
                                </div>
                            </div>
                            <TextInput
                                type={this.state.type}
                                name='password'
                                label={i18n.t('login:reset.password')}
                                labelSub={i18n.t('login:reset.strong')}
                                value={this.state.password}
                                onChange={this.inputChange}
                                error={this.state.errors.password}
                                outerClassName='mar-b24'
                                iconRight={
                                    <Icons
                                        icon='eye'
                                        className={
                                            this.state.type === 'password' ? 'icons-cross' : 'icons-cross active'
                                        }
                                        color='var(--neutral-900)'
                                        onClick={() => {
                                            this.setState({
                                                type: this.state.type === 'password' ? 'text' : 'password'
                                            })
                                        }}
                                    />
                                }
                            />
                            <div className='mar-b32'>
                                {requiresTerms && (
                                    <div className='checkboxWrapper mar-b4'>
                                        <CheckBox
                                            onClick={(event) => {
                                                let checked = event.target.checked
                                                this.setState({ approvedTerms: checked }, () => {
                                                    if (this.state.touched) {
                                                        this.validate()
                                                    }
                                                })
                                            }}
                                            checked={this.state.approvedTerms}
                                            className='mar-r5'
                                        >
                                            <span
                                                className={
                                                    'landing-register__terms ' +
                                                    (this.state.errors.terms ? 'error' : '')
                                                }
                                            >
                                                I accept the{' '}
                                                <a
                                                    href={this.props.siteMaster.termsUrl}
                                                    onMouseDown={(e) => {
                                                        e.preventDefault()
                                                        window.open(this.props.siteMaster.termsUrl, '_blank')
                                                    }}
                                                    target='_blank'
                                                >
                                                    Terms and Conditions
                                                </a>{' '}
                                                and{' '}
                                                <a
                                                    href={this.props.siteMaster.privacyUrl}
                                                    onMouseDown={(e) => {
                                                        e.preventDefault()
                                                        window.open(this.props.siteMaster.termsUrl, '_blank')
                                                    }}
                                                    target='_blank'
                                                >
                                                    Privacy Policy
                                                </a>
                                            </span>
                                        </CheckBox>
                                    </div>
                                )}
                                {this.props.siteMaster.siteId == 1 && (
                                    <div className='checkboxWrapper'>
                                        <CheckBox
                                            onClick={(e) => this.setState({ newsletterSignup: e.target.checked })}
                                            checked={this.state.newsletterSignup}
                                            className='mar-b24 mar-r5'
                                        >
                                            <span className='landing-register__terms'>
                                                {i18n.t('login:register.newsletter', {
                                                    siteName: this.props.siteMaster.siteName
                                                })}
                                            </span>
                                        </CheckBox>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                    <Button
                        className='button-primary button-fullwidth'
                        iconRight={<Icons icon='arrowRight' />}
                        onClick={this.handleSubmit}
                        disabled={this.state.processing}
                    >
                        {buttonText}
                    </Button>
                </LandingPageTemplate>
            )
            return (
                <div className='quickFlex' style={{ alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                    <Paper className='with_header'>
                        <div
                            className='paper_header'
                            style={{ backgroundColor: this.props.siteMaster.colours['$primary'], color: 'white' }}
                        >
                            <div className='quickFlex' style={{ alignItems: 'center' }}>
                                <Icons icon='alert' color={'#FFFFFF'} style={{ width: '20px', height: '20px' }} />
                                <div className='mar-l10 text-heavy' style={{ fontSize: 16 }}>
                                    {this.props.siteMaster.siteName} Account Invitation
                                </div>
                            </div>
                        </div>
                        <div className='paper_content'>
                            <div className='quickFlex' style={{ alignItems: 'flex-start' }}>
                                <div className='mar-r15'>
                                    <Avatar src={this.state.accountMasterData.logo} />
                                </div>
                                <div>
                                    <div className='text-heavy mar-b15'>
                                        Welcome to {this.state.accountMasterData.name}'s Email Marketing
                                    </div>
                                    {this.state.requiresPassword && (
                                        <div>
                                            You've been invited to join {this.state.accountMasterData.name}'s Email
                                            Marketing Account. Please enter your details below to get started...
                                        </div>
                                    )}
                                    {!this.state.requiresPassword && (
                                        <div>
                                            You've been invited to join {this.state.accountMasterData.name}'s Email
                                            Marketing Account. Please click Activate to get started...
                                        </div>
                                    )}
                                    {this.state.requiresPassword && (
                                        <div className='mar-t25'>
                                            <div className='quickFlex'>
                                                <div style={{ flex: '1' }}>
                                                    <TextInput
                                                        outerClassName='mar-b15 mar-r15'
                                                        type='text'
                                                        name='firstName'
                                                        label='Enter your First Name'
                                                        onKeyPress={this.inputChange}
                                                        onChange={this.inputChange}
                                                        error={this.state.errors.firstName}
                                                        focus={true}
                                                    />
                                                </div>
                                                <div style={{ flex: '1' }}>
                                                    <TextInput
                                                        outerClassName='mar-b15'
                                                        type='text'
                                                        name='lastName'
                                                        label='Enter your Last Name'
                                                        onKeyPress={this.inputChange}
                                                        onChange={this.inputChange}
                                                        error={this.state.errors.lastName}
                                                    />
                                                </div>
                                            </div>
                                            <TextInput
                                                autocomplete='new-password'
                                                type='password'
                                                name='password'
                                                label='Enter your password'
                                                className='txtInput lg'
                                                onChange={this.inputChange}
                                                error={this.state.errors.password}
                                                onKeyPress={this.inputChange}
                                            />
                                        </div>
                                    )}
                                    <Button
                                        className='button-primary mar-t25'
                                        text='Activate'
                                        onClick={this.handleSubmit}
                                        disabled={this.state.processing}
                                    />
                                </div>
                            </div>
                        </div>
                    </Paper>
                </div>
            )
        }
    }
}
